/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import NButton from '../../components/inputs/NButton';
import useUserAPI, { useUserHook } from '../../hooks/network/useUserAPI';
import { RouteEnums } from '../../Routes/RoutesConstant';
import useAuthHook from '../../hooks/custom-hooks/useAuthHook';
import NSearch from '../../components/inputs/NSearch';
import NDropdown from '../../components/inputs/NDropdown';
import NTable2 from '../../components/table/NTable2';
import useCustomerAPI from '../../hooks/network/useCustomerAPI';
import MobileEdit from '../../assets/svg/MobileEdit';
import MobileDelete from '../../assets/svg/MobileDelete';
import { successToaster } from '../../components/toaster/Toaster';
import NSearchableDropDown from '../../components/inputs/NSearchableDropdown';
import DownloadIcon from '@mui/icons-material/Download';

function ManageUsers() {
  const navigate = useNavigate();
  const [customerOptions, setCustomerOptions] = useState();
  const { deleteUser } = useUserAPI();
  const { downloadUserList, isLoading } = useUserAPI();
  const { getCustomers } = useCustomerAPI();
  const { isUserHasEditAndDeletePermission } = useAuthHook();

  const {
    lastElementRef,
    users,
    isPaginationLoading,
    searchString,
    setSearchString,
    setCustomerId,
    customerId,
    fetchUsers,
    setStatus,
    status,
    setPage,
    setUsers,
  } = useUserHook();

  const columns = [
    {
      width: '1%',
      key: 'userName',
      isSortable: false,
      columClassName: 'break-all',
      headerRender: () => (
        <>
          User <br /> Name
        </>
      ),
      rowRender: (rowData) => (
        <span>
          {rowData?.firstName} {rowData?.lastName}
        </span>
      ),
    },
    {
      width: '1%',
      key: 'userRole',
      title: 'User Type',
      isSortable: false,
      headerRender: () => (
        <>
          User <br /> Type
        </>
      ),
      rowRender: (rowData) => <span> {rowData?.userRole} </span>,
    },
    {
      width: '20%',
      key: 'customers',
      title: 'Customer',
      isSortable: false,
      rowRender: (rowData) => (
        <div>
          {rowData?.customers?.map((c, i) => (
            <div key={c.customer}>
              {`${c.customer} ${!(rowData.customers.length === i + 1) ? ', ' : ''}`}{' '}
            </div>
          ))}
        </div>
      ),
    },
    {
      width: '30%',
      key: 'projects',
      title: 'Projects',
      isSortable: false,
      rowRender: (rowData) => (
        <div>
          {rowData?.customers?.map((c, i) =>
            c?.projects?.map((p, pi) => (
              <div key={p}>
                {`${p} ${
                  !(rowData.customers.length === i + 1)
                    ? ', '
                    : c?.projects?.length !== pi + 1
                    ? ', '
                    : ''
                }`}{' '}
              </div>
            )),
          )}
        </div>
      ),
    },
    {
      width: '19%',
      key: 'email',
      title: 'Email ID',
      isSortable: false,
      rowRender: (rowData) => <span className='break-all'> {rowData?.email} </span>,
    },
    {
      width: '19%',
      key: 'loginEmail',
      title: 'User ID',
      isSortable: false,
      rowRender: (rowData) => <span className='break-all'> {rowData?.loginEmail} </span>,
    },
    {
      width: '10%',
      key: 'actions',
      title: 'Actions',
      columClassName: 'flex justify-end',
      rowRender: (rowData) =>
        !isUserHasEditAndDeletePermission(rowData?.userRole) ? null : (
          <div>
            {/* Mobile */}
            <div className='flex items-center justify-end gap-6 break:hidden'>
              <div onClick={() => onClickEdit(rowData?.userId)}>
                <MobileEdit />
              </div>
              <div onClick={() => onClickDelete(rowData?.userId)}>
                <MobileDelete />
              </div>
            </div>

            {/* Desktop */}
            <div className='hidden gap-4 break:flex'>
              <NButton
                className='action-edit-btn'
                variant='outlined'
                startIcon={<EditIcon />}
                onClick={() => onClickEdit(rowData?.userId)}
              >
                Edit
              </NButton>
              <NButton
                className='action-delete-btn'
                variant='outlined'
                startIcon={<DeleteIcon />}
                onClick={() => onClickDelete(rowData?.userId)}
              >
                Delete
              </NButton>
            </div>
          </div>
        ),
    },
  ];

  useEffect(() => {
    fetOptions();
  }, []);

  const fetOptions = async () => {
    try {
      const response = await getCustomers();
      setCustomerOptions(response);
    } catch {}
  };

  const onClickEdit = (id) => {
    navigate(`${RouteEnums.USER_EDIT}/${id}`);
  };

  const onClickDelete = (id) => {
    const response = window.confirm('Press ok to delete user?');
    if (response) {
      successToaster(response?.message || 'Deleted Successfully');
      handleDeleteUser(id);
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      const response = await deleteUser(userId);
      if (!response) return;
      fetchUsers();
    } catch {}
  };

  const getCustomerOptions = () => {
    if (customerOptions?.length) {
      return customerOptions?.map((o) => ({
        label: o.customerName,
        value: o.id?.toString(),
      }));
    }
    return [];
  };

  const optionValueCustomer = (cusVal) => {
    const selectedObj = customerOptions?.find((o) => o?.id?.toString() === cusVal?.toString());
    return { label: selectedObj?.customerName, value: selectedObj?.id?.toString() };
  };

  const handleDownloadUserList = async () => {
    try {
      const r = await downloadUserList();

      const url = window.URL.createObjectURL(new Blob([r]));

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `UserList.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch {}
  };

  return (
    <section className='n-table-wrapper pt-2'>
      {/* Mobile Header */}
      <div className='break:hidden'>
        <div className='mb-4 flex items-center justify-between'>
          <h2 className='font-semibold'>Users</h2>
          <div>
            <div className='flex items-center justify-end gap-2'>
              <NButton variant='Noutline' onClick={() => navigate(RouteEnums.USER_ADD)}>
                Add User
              </NButton>
              <NButton
                isLoading={isLoading}
                className='!bg-nblue text-nblue'
                onClick={handleDownloadUserList}
              >
                <DownloadIcon />
              </NButton>
            </div>
          </div>
        </div>
        <div className='mb-4'>
          <NSearch
            value={searchString}
            onChange={(e) => {
              setSearchString(e?.target?.value);
            }}
          />
        </div>
      </div>

      {/* Desktop */}
      <div className='mb-[30px] hidden flex-col items-start justify-between gap-5 break:flex xxl:flex-row xxl:items-center xxl:gap-10'>
        <div className='flex w-full flex-row gap-4 xxl:gap-8'>
          <div className='w-full lg:w-auto'>
            <NSearch
              value={searchString}
              onChange={(e) => {
                setSearchString(e?.target?.value);
              }}
            />
          </div>
          <div className='w-full xxl:w-4/12'>
            {/* <NDropdown
              label='Customer Name'
              name='customer'
              value={customerId}
              onChange={(e) => {
                setUsers(undefined);
                setPage(1);
                setCustomerId(e?.target?.value);
              }}
              className='w-full !bg-white'
              type='text'
              options={[{ label: 'Select Customer', value: '' }, ...getCustomerOptions()]}
            /> */}
            <NSearchableDropDown
              label='Customer Name'
              name='customer'
              value={optionValueCustomer(customerId)}
              onChange={(e, selectedValue) => {
                setUsers(undefined);
                setPage(1);
                setCustomerId(selectedValue?.value);
              }}
              className='w-full !bg-white'
              type='text'
              options={[{ label: 'Select Customer', value: '' }, ...getCustomerOptions()]}
            />
          </div>
          <div className='w-full xl:w-[20%]'>
            <NDropdown
              label='Status'
              name='status'
              value={status}
              onChange={(e) => {
                setUsers(undefined);
                setPage(1);
                setStatus(e?.target?.value);
              }}
              className='w-full !bg-white'
              type='text'
              options={[
                { label: 'Select Status', value: '' },
                { label: 'Active', value: 1 },
                { label: 'In- Active', value: 0 },
              ]}
            />
          </div>
        </div>
        <div className='flex items-center justify-start gap-2 xxl:w-3/12 xxl:justify-end'>
          <NButton
            className='flex-shrink-0 flex-nowrap !bg-nblue text-nblue'
            onClick={() => navigate(RouteEnums.USER_ADD)}
          >
            <span className='flex flex-shrink-0'>Add User</span>
          </NButton>
          <NButton
            isLoading={isLoading}
            className='!bg-nblue !px-2 text-nblue'
            onClick={handleDownloadUserList}
            title='Download user list'
          >
            <DownloadIcon />
          </NButton>
        </div>
      </div>

      <div className={`${users?.length ? 'ntable-container' : ''}`}>
        <NTable2
          isLoading={isPaginationLoading}
          rows={users || []}
          columns={columns}
          lastElementRef={lastElementRef}
        />{' '}
      </div>
    </section>
  );
}

ManageUsers.propTypes = {};

export default ManageUsers;
